/**
 * FEEDBACK (C1) — desenha um formulário do antigo seção por seção (a autoavaliação no link público e na ficha, a
 * avaliação na ficha). Títulos, marcadores ("Bloco 01 / 05") e perguntas são os literais do conteúdo versionado.
 */
import { CampoDoFormulario } from './CampoDoFormulario';
import type { SecaoDoFormulario } from '@/lib/feedback/feedback-store';
import { perguntaVisivel, rotuloDaPergunta, type Respostas } from '@/lib/feedback/formulario';

interface Props {
  secoes: SecaoDoFormulario[];
  respostas: Respostas;
  aoMudar: (chave: string, valor: string | string[] | null) => void;
  somenteLeitura?: boolean;
  aCadaTecla?: boolean;
}

export function FormularioDeSecoes({ secoes, respostas, aoMudar, somenteLeitura, aCadaTecla }: Props) {
  return (
    <div className="space-y-8">
      {secoes.map((s) => (
        <section key={s.id} className="space-y-4" data-testid={`secao-${s.id}`}>
          {(s.tag || s.titulo) && (
            <header className="space-y-1">
              {s.tag && (
                <p className="text-xs font-semibold uppercase tracking-[0.08em] text-ink-3 dark:text-ink-dark-3">
                  {s.tag}
                  {s.rotulo && <span> · {s.rotulo}</span>}
                </p>
              )}
              {s.titulo && <h3 className="font-display text-lg font-medium text-ink-1 dark:text-ink-dark-1">{s.titulo}</h3>}
            </header>
          )}
          {s.perguntas
            .filter((p) => perguntaVisivel(p, respostas))
            .map((p) => (
              <div key={p.id} className={p.condicional_a ? 'ml-4 border-l-2 border-line pl-4 dark:border-line-dark' : undefined}>
                <CampoDoFormulario
                  pergunta={{ ...p, texto: rotuloDaPergunta(p, s) }}
                  valor={respostas[p.id] as string | string[] | null | undefined}
                  aoConfirmar={(v) => aoMudar(p.id, v)}
                  somenteLeitura={somenteLeitura}
                  aCadaTecla={aCadaTecla}
                />
              </div>
            ))}
        </section>
      ))}
    </div>
  );
}
